import httpCommon from "../../http-common";

const initialiseNewStudent = () => {
  return {
    id: "",
    firstName: "",
    lastName: "",
    school: {id: 0},
    year: "",
    parentName: "",
    address: "",
    emailAddress: "",
    phoneNumber: "",
    class: {},
    createdAt: "",
    updatedAt: "",
    notes: "",
    parentNotes: "",
  };
}

const getAllForParent = async() => {
  //parent email is sent in the header
  const students = await httpCommon.http.get(`/students`);
  console.log('retrieved students for parent', students);
  return students?.data?.data;
};

const create = async (student) => {
  student.schoolId = student.school.id;
  return await httpCommon.http.post(`/students`, student);
};

const enroll = async (student, schoolYear, enrolmentNotes) => {
  return await httpCommon.http.post(`/students/${student.id}/enroll?schoolYear=${schoolYear}`, {notes: enrolmentNotes});
};

const StudentService = {
  getAllForParent,
  create,
  enroll,
  initialiseNewStudent,
};

export default StudentService;